// extracted by mini-css-extract-plugin
export default {"noSpinner":"HxfTextfieldNumber_noSpinner__stN3D"};